import { render, staticRenderFns } from "./PhoneCard.vue?vue&type=template&id=16cd83ea&scoped=true&"
import script from "./PhoneCard.vue?vue&type=script&lang=js&"
export * from "./PhoneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd83ea",
  null
  
)

export default component.exports